import { downloadData } from "../util/download";

export class AnimationDownloader {
  private audioContext: AudioContext;
  private recorder: MediaRecorder;

  public constructor(canvas: HTMLCanvasElement, audio: HTMLAudioElement) {
    // Firefox requires that canvas's contexts be obtained before their
    // capture stream or else a NS_ERROR_NOT_INITIALIZED error occurs
    canvas.getContext("2d");
    const videoStream = canvas.captureStream();

    this.audioContext = new AudioContext();
    const streamDestination = this.audioContext.createMediaStreamDestination();
    const audioSource = this.audioContext.createMediaElementSource(audio);
    audioSource.connect(streamDestination);
    const audioStream = streamDestination.stream;

    const tracks = videoStream.getTracks().concat(audioStream.getTracks());
    const overallStream = new MediaStream(tracks);
    this.recorder = new MediaRecorder(overallStream);

    this.recorder.ondataavailable = e => {
      const fileName = `${audio.src.split("/").at(-1)}.webm`;
      downloadData(e.data, fileName);
    };
  }

  public startRecording = async () => {
    if (this.audioContext.state === "suspended") {
      // Due to autoplay restrictions, audio contexts created
      // before a click on the page (say, on page load when visited
      // from a link) will be suspended and we need to manually resume it
      await this.audioContext.resume();
    }
    this.recorder.start();
  };

  public stopRecording = () => {
    this.recorder.stop();
  };

  public isRecording = () => this.recorder.state === "recording";
}
